import RatingInput from '@/components/app/formItem/RatingInput';
import { Row, Col, Form } from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

const requiredRule = {
  required: true,
  message: <Trans>VALIDATE_REQUIRED</Trans>,
};
type Props = {
  disabled: boolean;
};
export default function OtherItem({ disabled }: Props) {
  const { t } = useTranslation();
  return (
    <Row gutter={6}>
      <Col md={6} xs={24}>
        <Form.Item label={t('facilityReviewRate')} name="comprehensiveRate" rules={[requiredRule]}>
          <RatingInput disabled={disabled} className="input-value-color" />
        </Form.Item>
      </Col>
      <Col md={24} xs={24}>
        <Form.Item label={t('facilityReviewDetail')} name="details">
          <TextArea autoSize={{ minRows: 3 }} className="input-value-color" disabled={disabled} />
        </Form.Item>
      </Col>
    </Row>
  );
}
